// AutoGenerated
import { EnmKayitDurum } from "../enums/EnmKayitDurum"
import { HesapSarkiSesKayitNotlarModel } from "../businessModels/HesapSarkiSesKayitNotlarModel"

export class HesapSarkiSesKayitModel {
    hesapModelId!: string;
    sarkiModelId!: string;
    sesGrupId!: string;
    midiEslikVarMi!: boolean;
    midiEslikHizi!: number | null;
    kayitDurum!: EnmKayitDurum;
    yorumlar!: string | null;
    resimIcerikId!: string | null;
    orijinalPdfIcerikId!: string | null;
    sesIcerikId!: string;
    notlar!: HesapSarkiSesKayitNotlarModel[];
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}